import React, { memo } from 'react';
import Button from '../../../Button';
import palette from '../../../styles/palette';
import { CONFIRM } from '../../../../constants/strings';

const TransferButtons = ({ onClickConfirm, disabled }) => (
  <Button
    data-test-id="accept"
    variant="contained"
    disabled={disabled}
    bgColor={palette.modalButtons.blue}
    border="1px solid #0060A2"
    onClick={onClickConfirm}
    opacityDisabled={0.38}
  >
    {CONFIRM}
  </Button>
);

export default memo(TransferButtons);
